import {Card} from "../model/types";
import {MainDiamondCard} from "../ui/MainDiamondCard";
import styles from "./MainDiamonds.module.scss";

type Props = {
    cards: Card[];
}

export const MainDiamondsDesktop = ({cards}: Props) => {
    return (
        <div className={`globalContainer`}>
            <div className={styles.cards}>
                {cards.map((card) => {
                    return (
                        <MainDiamondCard key={card.link} card={card} className={styles.card} />
                    );
                })}
            </div>
        </div>
    );
}
